import { render, staticRenderFns } from "./subject-mng.vue?vue&type=template&id=ed999138"
import script from "./subject-mng.vue?vue&type=script&lang=js"
export * from "./subject-mng.vue?vue&type=script&lang=js"
import style0 from "./subject-mng.vue?vue&type=style&index=0&id=ed999138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports